import styled from "styled-components";
import { pagePadding } from "_/style/layout";
import { Icon } from "_/components/icon";

export const QueuePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  color: ${(p) => p.theme.text.default};
  ${pagePadding};
`;

export const QueuePageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
`;

export const QueuePageTitle = styled.h1`
  margin: 0;
`;

export const QueuePageInfo = styled.p`
  margin: 0;
  color: ${(p) => p.theme.text.muted};
`;

export const EmptyState = styled.div`
  padding: 1rem;
  border: 1px dashed ${(p) => p.theme.divider.small};
  border-radius: 8px;
`;

export const HandleColumnHeader = styled.div`
  padding-left: 0.5rem;

  ${Icon} {
    font-size: 1rem;
  }
`;

export const HandleCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.theme.text.muted};
  cursor: grab;
  font-size: 1rem;
  padding-left: 0.5rem;

  &:active {
    cursor: grabbing;
  }
`;

export const ActionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const MultiLineCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

export const SubmittedCell = styled(MultiLineCell)``;

export const SubmittedAgo = styled.span`
  color: ${(p) => p.theme.text.muted};
  font-size: 0.85rem;
`;

export const MaterialsCell = styled(MultiLineCell)`
  & > div {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
  }
`;

export const LoadingMessage = styled.div`
  padding: 1rem;
  border-radius: 8px;
  background-color: ${(p) => p.theme.background.primary};
  color: ${(p) => p.theme.text.muted};
  text-align: center;
`;

export const TableWrapper = styled.div``;
export const DraggableRow = styled.tr`
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  user-select: none;
  position: relative;
  cursor: grab;
  transition: opacity 0.15s ease;

  &[data-dragging="true"] {
    cursor: grabbing;
    opacity: 0.4;
  }

  /* Drop indicator line at top of row */
  &[data-indicator-before="true"]::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: ${(p) => p.theme.color.palette.electricBlue};
    pointer-events: none;
    display: block;
  }

  /* Drop indicator line at bottom of row */
  &[data-indicator-after="true"]::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: ${(p) => p.theme.color.palette.electricBlue};
    pointer-events: none;
    display: block;
  }
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  gap: 0.25rem;
`;

export const Label = styled.label`
  font-size: 0.85rem;
  color: ${(p) => p.theme.text.default};
`;

export const Warning = styled.div`
  color: ${(p) => p.theme.text.default};
  border: 1px solid ${(p) => p.theme.color.palette.sunsetOrange};
  border-radius: 6px;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  background-color: ${(p) => p.theme.background.secondary};
`;
